import { Box, chakra, Divider, Flex, keyframes, Stack, Text, UnorderedList, VStack } from '@chakra-ui/react';
import { TiArrowRight } from 'react-icons/ti';
import ListItemResource from './ListItemResource';
import { useNavigate } from 'react-router-dom';
import { ISelectiveProcessResource } from '../../../../../services/hooks/Resources/useRequestResources';
import { IDefaultObject } from '../../../../../services/hooks/Registration/useGetRegistration';
import React from 'react';

const openIn = keyframes`
  from {
    opacity: 0;
    height: 0px;
  }
  to {
    opacity: 1;
    height: 100%;
  }
`;

const AnimatedBoxResourceList = chakra(VStack, {
  baseStyle: {
    animation: `${openIn} 1000ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

interface IOwnProps {
  resourceList?: ISelectiveProcessResource[];
  selectiveProcess: IDefaultObject;
}

const ResourceListMobile: React.FC<IOwnProps> = ({ resourceList, selectiveProcess }) => {
  const navigate = useNavigate();

  const resourceBySelectiveProcess =
    resourceList && resourceList?.find((resource) => resource.selective_process_id === selectiveProcess.id);

  return (
    <Stack h="full" justifyContent="center">
      <AnimatedBoxResourceList gap={0}>
        <Text
          bgColor="primaryColor"
          color="white"
          boxSizing="border-box"
          py={1}
          mb={2}
          px={5}
          fontWeight="bold"
          fontSize="small"
          h="fit-content"
          textTransform="uppercase"
        >
          {selectiveProcess.name}
        </Text>
        <Flex mt={3} w="full" ml={6} alignItems="center" gap={2}>
          <Box>
            <TiArrowRight color="#0064de" size={20} />
          </Box>
          <Text
            fontSize="sm"
            cursor="pointer"
            onClick={() => {
              navigate(`/painel/impugnacao/${selectiveProcess?.id}?selective_process=${selectiveProcess.id}`);
            }}
            color="colorLink"
            h="fit-content"
          >
            Impugnação contra o edital
          </Text>
        </Flex>

        {resourceBySelectiveProcess?.vacancies?.map((vacancie, index) => (
          <UnorderedList w="full" ml={0} key={index} listStyleType={'""'}>
            {vacancie?.resources?.map((resource) => (
              <React.Fragment key={resource.resource_id}>
                <Box px={2} pb={3} pt={4}>
                  <Divider w="100%" borderColor="gray.300" />
                </Box>
                <ListItemResource data={resource} selectiveProcessId={selectiveProcess.id} />
              </React.Fragment>
            ))}
          </UnorderedList>
        ))}
      </AnimatedBoxResourceList>
    </Stack>
  );
};

export default ResourceListMobile;
